import SanitizedGrid from "../../../components/SanitizedGrid";
import WaveSelectionAndWaveInfo from "./WaveSelectionAndWaveInfo";
import { Grid, Typography } from "@material-ui/core";
import CustomDatePickerInput from "../../../components/CustomDatePickerInput";
import moment from "moment";
import React from "react";
import CustomNumberInput from "../../../components/CustomNumberInput";
import { useField } from "react-final-form";
import { availableOnlySuperAdmin } from "utils/validation";
import { Alert } from "@material-ui/lab";

const SelectWaveAndEffectiveDateSection = () => {
  const formOptimizationConstraintsChangedField = useField(
    "formOptimizationConstraintsChanged",
  );

  return (
    <SanitizedGrid container spacing={2}>
      <WaveSelectionAndWaveInfo />

      <Grid item xs={12}>
        <Typography variant="subtitle2">Next Effective Date</Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <CustomDatePickerInput
          name="nextEffectiveDate"
          label="Next Effective Date"
          min={moment().add(1, "day").format("Y-MM-DD")}
          disableValue={!availableOnlySuperAdmin()}
        />
        {!availableOnlySuperAdmin() && (
          <Alert severity="warning" style={{ marginTop: "8px" }}>
            <Typography variant="body2">
              The Next Effective Date can only be edited by a Super Admin.
            </Typography>
          </Alert>
        )}
      </Grid>
      <Grid item xs={12} md={8}></Grid>

      <Grid item xs={12}>
        <Typography variant="subtitle2">
          AI Route Optimisation Parameter
        </Typography>
      </Grid>

      <Grid item xs={12} md={4}>
        <CustomNumberInput
          label="Desired Route Duration (Minutes)"
          source="desiredRouteDuration"
          isRequired
          isPositiveValue
          onChange={() => {
            formOptimizationConstraintsChangedField.input.onChange(true);
          }}
        />
      </Grid>
      <Grid item xs={12} md={8}></Grid>

      <Grid item xs={12} md={4}>
        <CustomNumberInput
          label="Max Vehicle Capacity"
          source="maxVehicleCapacity"
          isRequired
          isPositiveValue
          onChange={() => {
            formOptimizationConstraintsChangedField.input.onChange(true);
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <CustomNumberInput
          label="Max Bus Stop Duration (Minutes)"
          source="maxStopTime"
          isRequired
          isPositiveValue
          onChange={() => {
            formOptimizationConstraintsChangedField.input.onChange(true);
          }}
        />
      </Grid>
    </SanitizedGrid>
  );
};

export default SelectWaveAndEffectiveDateSection;
